import {MockupType} from "./mockup-type.enum";

export class MockupDataModel {
  message: string | any;
  type: MockupType | any;

  constructor(message: any, type: any) {
    this.message = message;
    this.type = type;
  }

  public static error(message: string) {
    return new MockupDataModel(message, MockupType.ERROR);
  }

  public static success(message: string) {
    return new MockupDataModel(message, MockupType.SUCCESS);
  }

  public static info(message: string) {
    return new MockupDataModel(message, MockupType.INFO);
  }
}
